/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import Image from '../../../image/Image.jsx';

import LocationContent from './LocationContent/LocationContent.jsx';
import LocationMap from './LocationMap/LocationMap.jsx';
import LocationHeader from './LocationHeader/LocationHeader.jsx';

const LocationApp = ({ data }) => {
  const { headline, maps, defaultKey, locations, labels } = data;
  const [currentMap, setCurrentMap] = useState(locations[defaultKey]?.map || Object.keys(maps)[0]);
  const [currentPin, setCurrentPin] = useState(defaultKey);

  useEffect(() => {
    const validPinsForMap = Object.keys(locations).filter((key) => locations[key].map === currentMap);

    if (validPinsForMap.length > 0 && !validPinsForMap.includes(currentPin)) {
      setCurrentPin(validPinsForMap[0]);
    }
  }, [currentMap, currentPin, locations]);

  // Handler für die Auswahl eines Pins sowohl von der Karte als auch vom Akkordeon
  const handlePinSelect = (pinKey) => {
    if (pinKey && locations[pinKey]) {
      // Überprüfen, ob der Pin auf der aktuellen Karte ist
      if (locations[pinKey].map !== currentMap) {
        // Wenn nicht, wechsle zur richtigen Karte
        setCurrentMap(locations[pinKey].map);
      }
      // Setze den Pin
      setCurrentPin(pinKey);
    }
  };

  return (
    <div className="location__wrapper">
      <LocationHeader headline={headline} />
      <LocationContent
        title={labels?.sidebarTitle || 'Wo Sie uns finden'}
        locations={locations}
        currentPin={currentPin}
        currentMap={currentMap}
        onPinSelect={handlePinSelect}
      >
        <LocationMap
          headline={headline}
          maps={maps}
          currentMap={currentMap}
          onMapSwitch={setCurrentMap}
          currentPin={currentPin}
          title={`${labels.mapLabel} ${maps[currentMap].label}`}
          locations={locations}
          setCurrentPin={handlePinSelect}
        />
      </LocationContent>
    </div>
  );
};

export default LocationApp;
